<template>
    <Dashboard
        :title="__('Edit engrave', null, $page.props.profile_locale)"
    >
        <h2 class="border-b-2 text-xl border-gray-200 mb-4">{{__('Edit engrave', null, $page.props.profile_locale)}}</h2>

        <div>
                <div class="flex flex-col" v-if="step == 1">
                    <div class="text-red-500 text-sm font-bold">{{ validMessage }}</div>

                    <div>
                        <Button
                            @click="ev => { if(form.option) removeTemplate() }"
                            padding="sm"
                            :class="[
                                form.option ? '' : 'opacity-50'
                            ]"
                        >{{__('Remove selected template', null, $page.props.profile_locale)}}</Button>
                        <CustomSelect
                            :label="__('Select saved engrave', null, $page.props.profile_locale)"
                            :data="options"
                            :modelValue="form.option ? form.option : options.find(x => x.id === engrave.option_id)"
                            @update:modelValue="ev => {
                                form.area = ev.area;
                                form.option = ev;
                            }"
                            class="my-3 w-full"
                        />

                        <CanvasArea
                            :image="engrave.image.url"
                            :area="form.area"
                            @update-area="ev => {
                                form.area = ev;
                                form.new_area = true;
                                form.option = null;
                            }"
                        />
                        <div class="grid grid-cols-4 gap-3 mt-3" v-if="form.area">
                            <InputLabel
                                :label="__('Pozycja X', null, $page.props.profile_locale)"
                                type="number"
                                :min="0"
                                id="area.x"
                                step="0.5"
                                :readOnly="!form.new_area"
                                v-model.number="form.area.x"
                            />
                            <InputLabel
                                :label="__('Pozycja Y', null, $page.props.profile_locale)"
                                type="number"
                                :min="0"
                                id="area.y"
                                step="0.5"
                                :readOnly="!form.new_area"
                                v-model.number="form.area.y"
                            />
                            <InputLabel
                                :label="__('Pozycja W', null, $page.props.profile_locale)"
                                type="number"
                                :min="0"
                                id="area.w"
                                step="0.5"
                                :readOnly="!form.new_area"
                                v-model.number="form.area.w"
                            />
                            <InputLabel
                                :label="__('Pozycja H', null, $page.props.profile_locale)"
                                type="number"
                                :min="0"
                                id="area.h"
                                step="0.5"
                                :readOnly="!form.new_area"
                                v-model.number="form.area.h"
                            />
                            <div class="col-span-2" v-if="options.length && !form.new_area">
                                <!-- <input v-model="form.new_area" id="edit" type="checkbox">
                                <label class="ml-2" for="edit">Zmień współrzedne graweru</label> -->
                                <Checkbox
                                    label="Zmień współrzedne graweru"
                                    v-model="form.new_area"
                                    type="checkbox"
                                    id="edit"
                                />
                            </div>
                            <div class="col-span-2" v-else-if="form.new_area">
                                <InputLabel
                                    :label="__('Nazwa nowego graweru', null, $page.props.profile_locale) + ' ('+ __('optional', null, $page.props.profile_locale) + ')'"
                                    v-model="form.engrave_name"
                                    id="engrave_name"
                                />
                                <small>{{__('By entering a name, you will add a new template', null, $page.props.profile_locale)}}</small>
                            </div>
                        </div>

                        <div class="pt-5 mt-10 border-t border-gray-300 grid grid-cols-2 gap-3">
                            <InputLabel
                                :label="__('Title', null, $page.props.profile_locale)"
                                v-model="form.name"
                                id="name"
                                class="col-span-2"
                            />
                            <InputLabel
                                :label="__('Max characters', null, $page.props.profile_locale)"
                                type="number"
                                id="max_length"
                                :modelValue="form.option ? form.option.max_characters : form.max_length"
                                :readOnly="!form.new_area"
                                @update:modelValue="ev => {
                                    form.max_length = Number(ev)
                                }"
                            />
                            <InputLabel
                                :label="__('Max lines', null, $page.props.profile_locale)"
                                type="number"
                                id="max_lines"
                                :modelValue="form.option ? form.option.max_lines : form.max_lines"
                                :readOnly="!form.new_area"
                                @update:modelValue="ev => {
                                    form.max_lines = Number(ev)
                                }"
                            />
                            <InputLabel
                                :label="__('Text color', null, $page.props.profile_locale)"
                                type="color"
                                id="color"
                                :size="null"
                                v-model="form.color"
                            />
                        </div>
                    </div>

                    <div class="flex justify-start mt-3">
                        <Button
                            padding="sm"
                            class="text-sm"
                            @click="saveForm"
                        >
                            Zapisz
                            <SvgIcon
                                class="mx-auto"
                                name="save"
                            />
                        </Button>
                    </div>
                </div>
        </div>
    </Dashboard>
</template>

<script>
    import Dashboard from '@/Layouts/Dashboard';
    import SvgIcon from 'UI/SvgIcon';
    import Button from 'UI/Button';
    import InputLabel from 'UI/InputLabel';

    import CanvasArea from 'COMP/Canvas/CanvasArea';
    import CustomSelect from 'UI/CustomSelect';

    import { ref } from '@vue/reactivity';
    import { useForm, usePage } from '@inertiajs/inertia-vue3';
    import { watch } from '@vue/runtime-core';
    import Checkbox from 'UI/Checkbox';

    import {
        isObjectEmpty,
    } from 'helper';
import { Inertia } from '@inertiajs/inertia';
    const MIN_H = 30;

    export default {
        components: {
            Dashboard,
            SvgIcon,
            Button,
            CanvasArea,
            InputLabel,
            CustomSelect,
            Checkbox,
        },
        props: {
            engrave: [Object, Array],
            options: [Object, Array],
        },
        setup(props) {

            const form = useForm({
                image: props.engrave.image,
                area: props.engrave.option.area,
                name: props.engrave.name,
                max_length: props.engrave.option.max_characters,
                max_lines: props.engrave.option.max_lines,

                new_area: false,
                option: props.engrave.option,
                color: props.engrave.color,
                engrave_name: null,
            });

            watch(() => form.new_area, (val) => {
                if(val) form.option = null;
            })

            const
                engraveImage = ref(null),
                step = ref(1),
                back = ref(false),
                validMessage = ref(null);

            const
                backClicked = () => {
                    back.value = !back.value;
                    step.value--;
                },
                saveForm = () => {
                    if(!isObjectEmpty(form.area)) {
                        if(form.area.h < MIN_H) {
                            validMessage.value = app.__('Podaj wysokość większą bądź równą 35 !');
                            setTimeout(() => validMessage.value = null, 4000);
                        }
                    }
                    else {
                        validMessage.value = app.__('Wybierz obszar do graweru!');

                        setTimeout(() => validMessage.value = null, 4000);
                    }
                    let arr = {};
                    for (const [key, value] of Object.entries(form.data())) {
                        if(!value) {

                            if(!form.option && key != 'new_area' && key != 'option' && key != 'engrave_name') {
                                arr[key] = app.__('validation-inline.required');
                            }
                            else {
                                if( (key == 'name' || key == 'color') && !value) arr[key] = app.__('validation-inline.required');
                            }
                        }

                        if(key == 'area') {
                            ['x', 'y', 'w', 'h'].forEach((el) => {
                                if(!value[el]) arr[key + '.' + el] = app.__('validation-inline.required');
                            });
                        }
                    }
                    if(Object.keys(arr).length > 0) usePage().props.value.errors = arr;
                    else if(!validMessage.value){
                        form.post(route('dashboard.engrave.update', props.engrave.id), {
                            preserveScroll: true,
                            onSuccess: () => {
                                form.reset();
                            },
                        })
                    }
                };

            function removeTemplate(){
                let arr = props.options.find(x => x.id === form.option.id).engraves;
                let info = '';
                if(arr.length) info += 'Szablon ma przypisany grawer dla:\n\n';

                arr.forEach(el => {
                    info += el.locale.toUpperCase() + ' - ' + el.name + '\n';
                });
                if(arr.length) info += '\nPrzed jego usunięciem zalecamy zmianę szablonów dla tych produktów';

                if(!arr.length){
                    Inertia.post(route('remove.template', form.option.id), null, {
                        preserveScroll: true,
                        onSuccess: () => {
                            form.option = props.options.find(x => x.id === props.engrave.option_id);
                        }
                    })
                }
                else alert(info);
            }

            return {
                backClicked,
                saveForm,

                form,
                back,
                step,
                engraveImage,
                validMessage,

                removeTemplate,
            }
        }

    }
</script>
<style lang="postcss">

.engrave-canvas canvas{
    @apply rounded-md;
}
</style>
